import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Add global error handler
window.onerror = (message, source, lineno, colno, error) => {
  console.error('Global error:', { message, source, lineno, colno, error });
};

// Add unhandled promise rejection handler
window.onunhandledrejection = (event) => {
  console.error('Unhandled promise rejection:', event.reason);
};

// Debug info
if (import.meta.env.DEV) {
  console.log('Environment:', import.meta.env);
  console.log('Initial localStorage:', { ...localStorage });
}

// Create root with error handling
const container = document.getElementById('root');
if (!container) {
  throw new Error('Failed to find root element');
}

const root = ReactDOM.createRoot(container);

// Render app with error boundary
try {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} catch (error) {
  console.error('Failed to render app:', error);
  container.innerHTML = `
    <div style="
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100vh;
      padding: 20px;
      text-align: center;
    ">
      <h1 style="margin-bottom: 20px;">Failed to load application</h1>
      <p style="margin-bottom: 20px;">Please try refreshing the page. If the problem persists, clear your browser data and try again.</p>
      <button 
        onclick="window.location.reload()" 
        style="
          padding: 10px 20px;
          background: #4A90E2;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        "
      >
        Reload Page
      </button>
    </div>
  `;
}
